export default class variety {
  constructor(options = {}) {
    this.data = {
      name: '',
      price: options.price || '',
      purchasePrice: '',
      quantity: 0,
      main_balance: 0,
      old_quantity: 0,
      images: [],
      barcode: '',
      SKU: '',
      discount: '',
      discountType: 'none',
      discountUntil: '',
      productGifts: {
        gifts: [],
        shouldMerge: false,
      }
    }
    this.present = false // الان تو لیست داریمش یا نه
  }
}
